import { defineStore } from "pinia"
import { ListarUsuarios } from "@/repositorios/usuarios/usuarios.modelo"

export type PerfilDeOrganizacao = {
  id: string
  nome: string
  descricao: string
}

import i18n from "@/i18n"

const { t } = i18n.global

export const opcoesPerfisDeOrganizacao: PerfilDeOrganizacao[] = [
  {
    id: "administrador",
    nome: t("administrador"),
    descricao: t("descricaoAdministrador"),
  },
  {
    id: "supervisor",
    nome: t("supervisor"),
    descricao: t("descricaoSupervisor"),
  },
  {
    id: "gerente",
    nome: t("gerente"),
    descricao: t("descricaoGerente"),
  },
  {
    id: "pessoal",
    nome: t("pessoal"),
    descricao: t("descricaoPessoal"),
  },
  {
    id: "visualizador",
    nome: t("visualizador"),
    descricao: t("descricaoVisualizador"),
  },
]

type IUsuariosStates = {
  email: string
  senha: string
  perfilDeOrganizacao: string
  usuariosResponsaveis: string[]
  usuariosAtivos: ListarUsuarios[]
  usuariosInativos: ListarUsuarios[]
  opcoesPerfisDeOrganizacao: PerfilDeOrganizacao[]
}

export const usuariosStore = defineStore("usuarios", {
  state: (): IUsuariosStates => {
    return {
      usuariosAtivos: [],
      usuariosInativos: [],
      email: "",
      senha: "",
      perfilDeOrganizacao: "",
      usuariosResponsaveis: [],
      opcoesPerfisDeOrganizacao,
    }
  },
  actions: {
    resetarUsuarios() {
      this.$reset()
    },
  },
})
